import type {
  AssetSchemaType,
  AssetStatusType,
} from "../schemas/AssetSchemas.ts";
import type { JobStatusType, JobType } from "../schemas/JobSchemas.ts";
import { fetchAndCollate, getFilterObject } from "../util/index.ts";
import type {
  GetListRequestType,
  GetListResponseType,
  ResourceAdapterType,
} from "../util/index.ts";
import { restAPI } from "./api.ts";

export type AssetAdapterType = Pick<
  ResourceAdapterType<AssetSchemaType>,
  "getList"
> & {
  updateStatusAsync: (params: {
    data: {
      asset_id: string;
      status: AssetStatusType;
      start_date?: string;
      end_date?: string;
    };
  }) => Promise<{ status: JobStatusType; job: JobType }>;
};

export const AssetAdapter: AssetAdapterType = {
  /**
   * Asset Search API
   * @see https://staging-carbon-hub-api.s3.us-west-2.amazonaws.com/openapi/index.html#/assets/searchAssets
   */
  getList: ({
    filters,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: GetListRequestType) => {
    return fetchAndCollate<AssetSchemaType>(
      ({ page, pageSize }) =>
        restAPI.nodeAPI.POST<GetListResponseType<AssetSchemaType>>({
          endpoint: "/assets/search",
          body: {
            page,
            page_size: pageSize,
            sort_by: sortBy,
            sort_direction: sortDirection,
            filter: getFilterObject(filters),
          },
        }),
      page,
      pageSize
    );
  },
  /**
   * Asset Update Async API
   * @see https://staging-carbon-hub-api.s3.us-west-2.amazonaws.com/openapi/index.html#/assets/update_asset_status_async
   */
  updateStatusAsync: ({ data }) =>
    restAPI.nodeAPI.POST({
      endpoint: `/assets/${data.asset_id}/update_status_async`,
      body: {
        status: data.status,
        start_date: data.start_date,
        end_date: data.end_date,
      },
    }),
};
